import { CalendarEventsResponse } from "@/schema"
import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchCalendarEvents } from "./api"

export function useFetchCalendarEvents(options: {
  calendarIds?: string[]
  startDate?: Date
  endDate?: Date
  enabled?: boolean
}) {
  const getContext = useApiContext()
  const bookId = useBookId()

  return useQuery<CalendarEventsResponse, Error>({
    queryKey: [
      "calendar-events",
      bookId,
      options.calendarIds,
      options.startDate?.toISOString().split("T")[0],
      options.endDate?.toISOString().split("T")[0],
    ],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context")
      return fetchCalendarEvents(context, options)
    },
    enabled: options.enabled ?? true,
  })
}
